<div class="nf-lab-req">
    <form *ngIf="form" [formGroup]="form">
        <!-- Header Section -->
        <div class="header">
            <div class="left-section">
                <div class="logo-section">
                    <div class="logo">
                        <img
                            src="assets/libs/ui/lab-req/nf-lab.png"
                            alt="Newfoundland and Labrador Logo"
                        />
                    </div>
                    <div class="barcode">
                        <img
                            src="assets/libs/ui/lab-req/nf-lab-barcode.png"
                            alt="Barcode"
                        />
                    </div>
                </div>
                <h1>Outpatient Specimen Collection<br />Requisition</h1>
            </div>

            <div class="right-section">
                <!-- Patient Information -->
                <div class="patient-info" formGroupName="patient">
                    <div class="form-row">
                        <label>HCN:</label>
                        <input formControlName="hcn" type="text" />
                    </div>
                    <div class="form-row">
                        <label>Province/Territory:</label>
                        <input
                            formControlName="province"
                            type="text"
                            value="NL"
                        />
                        <label>Expiry:</label>
                        <input formControlName="expiry" type="text" />
                    </div>
                    <div class="form-row">
                        <label>Name:</label>
                        <input formControlName="name" type="text" />
                    </div>
                    <div class="form-row">
                        <label>Date of Birth:</label>
                        <input formControlName="dob" type="text" />
                        <label>Sex:</label>
                        <div class="radio-group">
                            <label
                                ><input
                                    type="radio"
                                    formControlName="sex"
                                    value="M"
                                />M</label
                            >
                            <label
                                ><input
                                    type="radio"
                                    formControlName="sex"
                                    value="F"
                                />F</label
                            >
                            <label
                                ><input
                                    type="radio"
                                    formControlName="sex"
                                    value="UN"
                                />UN</label
                            >
                        </div>
                    </div>
                    <div class="form-row">
                        <label>Mailing Address:</label>
                        <input formControlName="address" type="text" />
                    </div>
                    <div class="form-row">
                        <label>City:</label>
                        <input formControlName="city" type="text" />
                    </div>
                    <div class="form-row">
                        <label>Province/Territory:</label>
                        <input formControlName="province" type="text" />
                        <label>Postal Code:</label>
                        <input formControlName="postalCode" type="text" />
                    </div>
                    <div class="form-row">
                        <label>Telephone: (Indicate Preferred)</label>
                        <div style="display: flex">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="homeTcheck"
                                />
                                Home</label
                            >
                            <input formControlName="homeT" type="text" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div style="display: flex">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="mobileTcheck"
                                />
                                Cell</label
                            >
                            <input formControlName="mobileT" type="text" />
                        </div>
                        <div style="display: flex">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="workTcheck"
                                />
                                Work</label
                            >
                            <input formControlName="workT" type="text" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-content">
            <!-- Provider Information -->
            <div class="provider-section left-section" formGroupName="provider">
                <div class="form-row">
                    <label>Ordering Provider's Name:</label>
                    <input formControlName="name" type="text" />
                </div>
                <div class="form-row">
                    <label>Clinic Name:</label>
                    <input formControlName="clinicName" type="text" />
                </div>
                <div class="form-row">
                    <label>Mailing Address:</label>
                    <input formControlName="address" type="text" />
                </div>
                <div class="form-row">
                    <label>City:</label>
                    <input formControlName="city" type="text" />
                </div>
                <div class="form-row">
                    <label>Province/Territory:</label>
                    <input formControlName="province" type="text" />
                    <label>Postal Code:</label>
                    <input formControlName="postalCode" type="text" />
                </div>
                <div class="form-row">
                    <label>Phone:</label>
                    <input formControlName="phone" type="text" />
                    <label>Fax:</label>
                    <input formControlName="fax" type="text" />
                </div>
                <div class="form-row">
                    <label>Signature:</label>
                    <img
                        *ngIf="form.value.signature as signature"
                        alt="Signature"
                        height="50px"
                        [src]="'assets/signatures/' + signature + '.png'"
                    />
                    <label>Date:</label>
                    <input formControlName="date" type="text" />
                </div>
            </div>

            <!-- Clinic Stamp Section -->
            <div class="clinic-stamp right-section" formGroupName="stamp">
                <label
                    ><b>Clinic Stamp</b>: (include fax, provider and
                    mnemonics)</label
                >
                <div class="stamp-box"></div>
                <div class="form-row">
                    <label>Ordering Provider's Meditech Mnemonic:</label>
                    <input formControlName="meditech" type="text" />
                </div>
                <div class="form-row">
                    <label>EMR Clinic Mnemonic:</label>
                    <input formControlName="mnemonic" type="text" />
                </div>
                <div class="form-row">
                    <label>COPY TO PROVIDER:</label>
                    <input formControlName="copyProvider" type="text" />
                </div>
            </div>

            <!-- Main Content - Two Columns -->
            <!-- Left Column -->
            <div class="test-section left-section">
                <!-- Diagnosis Section -->
                <div class="section" formGroupName="diagnosis">
                    <h3>DIAGNOSIS / RELEVANT HISTORY:</h3>
                    <textarea formControlName="diagnosis" rows="3"></textarea>
                </div>

                <!-- Hematology -->
                <div class="section" formGroupName="hematology">
                    <h3>HEMATOLOGY</h3>
                    <div class="checkbox-group">
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="cbc"
                                />CBC</label
                            >
                            <span>(Includes automated differential)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="pti"
                                />PTI</label
                            >
                            <div class="form-row">
                                <span>INR</span>
                                <label
                                    >Anticoagulant
                                    <textarea
                                        formControlName="anticoagulant"
                                        rows="1"
                                    ></textarea>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Immunohematology -->
                <div class="section" formGroupName="immunohematology">
                    <h3>IMMUNOHEMATOLOGY</h3>
                    <div class="checkbox-group">
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="bltyabs"
                                />BLTYABS</label
                            >
                            <span>Type and Screen</span>
                        </div>
                    </div>
                </div>

                <!-- Chemistry -->
                <div class="section" formGroupName="chemistry">
                    <h3>CHEMISTRY</h3>
                    <div class="checkbox-group">
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="glufa"
                                />GLUFA</label
                            >
                            <span>Glucose (Fast 8hr)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="gluco"
                                />GLUCO</label
                            >
                            <span>Glucose-Random (Non-fasting)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="gtt2h"
                                />GTT2H</label
                            >
                            <span>75 gm OGTT (Fast 8hr)</span>
                        </div>
                        <div class="checkbox-row">
                            <label style="font-size: 12px"
                                ><input
                                    type="checkbox"
                                    formControlName="g1hp50ggo"
                                />G1HP50GGO</label
                            >
                            <span>50 gm Prenatal Screen (Non-fasting)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="gttg"
                                />GTTG</label
                            >
                            <span
                                >75 gm OGTT (Fast 8hr; for PRE-NATAL use)</span
                            >
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="hba1cthb"
                                />HBA1CTHB</label
                            >
                            <span>Hemoglobin A1C</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="cr"
                                />CR</label
                            >
                            <span>Creatinine (with eGFR)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="sodiu"
                                />SODIU</label
                            >
                            <span>Sodium</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="potas"
                                />POTAS</label
                            >
                            <span>Potassium</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="bilto"
                                />BILTO</label
                            >
                            <span>Bilirubin, Total</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="alt"
                                />ALT</label
                            >
                            <span>Alanine Aminotransferase</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="calci"
                                />CALCI</label
                            >
                            <span>Calcium (with Albumin)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="urate"
                                />URATE</label
                            >
                            <span>Uric Acid</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="prote"
                                />PROTE</label
                            >
                            <span>Total Protein</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="album"
                                />ALBUM</label
                            >
                            <span>Albumin</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="creki"
                                />CREKI</label
                            >
                            <span>Creatine Kinase</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="hepfup"
                                />HEPFUP</label
                            >
                            <span>ALP, ALT (Reflex AST & Total Bilirubin)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="lipidp"
                                />LIPIDP</label
                            >
                            <span
                                >TChol, HDL, TG, Calculated LDL, non-HDLC</span
                            >
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="tsh"
                                />TSH</label
                            >
                            <span
                                >Thyroid Stimulating Hormone (Reflex fT4)</span
                            >
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="crphs"
                                />CRPHS</label
                            >
                            <span>C-Reactive Protein</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="ferri"
                                />FERRI</label
                            >
                            <span>Ferritin</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="psa"
                                />PSA</label
                            >
                            <span>Prostate Specific Antigen (PSA)</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column -->
            <div class="test-section right-section">
                <!-- Frequency Section -->
                <div class="section" formGroupName="frequency">
                    <div class="form-row">
                        <label>Frequency of Testing (For Repeat Testing)</label>
                        <input formControlName="frequency" type="text" />
                    </div>
                </div>

                <!-- Therapeutic Drug Monitoring -->
                <div class="section" formGroupName="therapeutic">
                    <h3>THERAPEUTIC DRUG MONITORING</h3>
                    <div class="drug-monitoring checkbox-group">
                        <div formGroupName="drug1">
                            <div class="checkbox-row">
                                <label
                                    ><input
                                        type="checkbox"
                                        formControlName="selected"
                                    />Drug #1</label
                                >
                                <input type="text" formControlName="name" />
                            </div>
                            <div class="form-row">
                                <label>Date and Time of Last Dose:</label>
                                <input
                                    formControlName="lastDoseDate"
                                    type="date"
                                    placeholder="YYYY/MM/DD"
                                />
                                <input
                                    formControlName="lastDoseTime"
                                    type="time"
                                    placeholder="HH:MM"
                                />
                            </div>
                            <div class="form-row">
                                <label>Date and Time of Next Dose:</label>
                                <input
                                    formControlName="nextDoseDate"
                                    type="date"
                                    placeholder="YYYY/MM/DD"
                                />
                                <input
                                    formControlName="nextDoseTime"
                                    type="time"
                                    placeholder="HH:MM"
                                />
                            </div>
                        </div>
                        <div formGroupName="drug2">
                            <div class="checkbox-row">
                                <label
                                    ><input
                                        type="checkbox"
                                        formControlName="selected"
                                    />Drug #2</label
                                >
                                <input type="text" formControlName="name" />
                            </div>
                            <div class="form-row">
                                <label>Date and Time of Last Dose:</label>
                                <input
                                    formControlName="lastDoseDate"
                                    type="date"
                                    placeholder="YYYY/MM/DD"
                                />
                                <input
                                    formControlName="lastDoseTime"
                                    type="time"
                                    placeholder="HH:MM"
                                />
                            </div>
                            <div class="form-row">
                                <label>Date and Time of Next Dose:</label>
                                <input
                                    formControlName="nextDoseDate"
                                    type="date"
                                    placeholder="YYYY/MM/DD"
                                />
                                <input
                                    formControlName="nextDoseTime"
                                    type="time"
                                    placeholder="HH:MM"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Urine Testing -->
                <div class="section" formGroupName="urineTesting">
                    <h3>URINE TESTING</h3>
                    <div class="checkbox-group">
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="urinap"
                                />URINAP</label
                            >
                            <span
                                >Urinalysis (reflex microscopic when
                                applicable)</span
                            >
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="hcgu"
                                />HCGU</label
                            >
                            <span>Pregnancy Test</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="malcrpu"
                                />MALCRPU</label
                            >
                            <span>Albumin/Creatinine Ratio (Microalbumin)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="urinc"
                                />URINC</label
                            >
                            <div class="form-row">
                                <span>Urine Culture</span>
                                <label
                                    ><input
                                        type="checkbox"
                                        formControlName="symptomatic"
                                    />Symptomatic</label
                                >
                                <label
                                    ><input
                                        type="checkbox"
                                        formControlName="pregnant"
                                    />Pregnant</label
                                >
                            </div>
                        </div>
                    </div>
                    <div class="form-row small-text">
                        (Urine cultures collected from indwelling catheters will
                        be rejected)
                    </div>
                    <div class="form-row">
                        <label>Antibiotics:</label>
                        <textarea
                            formControlName="antibiotics"
                            rows="1"
                        ></textarea>
                    </div>
                </div>

                <!-- Prenatal Screening -->
                <div class="section" formGroupName="prenatalScreening">
                    <h3>PRENATAL SCREENING</h3>
                    <div class="checkbox-group">
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="bltyabs"
                                />BLTYABS</label
                            >
                            <span>Type and Screen</span>
                        </div>
                        <div
                            class="checkbox-row"
                            style="grid-template-columns: 70px 1fr"
                        >
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="pns"
                                />PNS</label
                            >
                            <span
                                >Prenatal Serology
                                <span class="small-text"
                                    >(Includes HIV, Rubella, HBsAG, Syphilis
                                    Screen)</span
                                ></span
                            >
                        </div>
                    </div>
                </div>

                <!-- Microbiology -->
                <div class="section" formGroupName="microbiology">
                    <h3>MICROBIOLOGY</h3>
                    <div class="checkbox-group">
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="hivs"
                                />HIVS</label
                            >
                            <span>HIV Screen</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="tpalab"
                                />TPALAB</label
                            >
                            <span>Syphilis Screen</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="ctngdp"
                                />CTNGDP</label
                            >
                            <span>CT/NG Testing (Swab)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="ctngdpu"
                                />CTNGDPU</label
                            >
                            <span>CT/NG Testing (Urine)</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="hepdx"
                                />HEPDX</label
                            >
                            <span
                                >Hepatitis Diagnosis/Screening Panel (B and
                                C)</span
                            >
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="havabm"
                                />HAVABM</label
                            >
                            <span>Acute Hepatitis A Testing</span>
                        </div>
                        <div class="checkbox-row">
                            <label
                                ><input
                                    type="checkbox"
                                    formControlName="hbsab"
                                />HBSAB</label
                            >
                            <span>Hepatitis B Immunity</span>
                        </div>
                    </div>
                </div>

                <!-- Additional Requests -->
                <div class="section" formGroupName="additionalRequests">
                    <h3>ADDITIONAL REQUESTS (MUST BE PRINTED LEGIBLY)</h3>
                    <textarea
                        formControlName="requests"
                        rows="6"
                        style="
                            white-space: pre-wrap;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                        "
                    ></textarea>
                </div>
            </div>
        </div>

        <!-- Footer Notes -->
        <div class="footer-notes">
            <p>
                If fasting is required - do not eat or drink anything (except
                medications and/or water) for the time period indicated.
            </p>
            <p>
                If you need additional information about preparing for your lab
                test, please contact your local Laboratory Medicine services.
            </p>
            <p>
                Please note, some tests require an accompanying completed
                Special Authorization form before the test can proceed.
            </p>
        </div>

        <!-- Collection Information -->
        <div class="collection-info" formGroupName="collection">
            <div class="form-row">
                <label>DATE & TIME OF COLLECTION:</label>
                <input
                    formControlName="date"
                    type="date"
                    placeholder="YYYY/MON/DD"
                />
                <input formControlName="time" type="time" placeholder="HH:MM" />
                <label>Collector's Signature:</label>
                <textarea formControlName="signature" rows="1"></textarea>
            </div>
            <label>Collector's Notes:</label>
            <div class="form-row">
                <textarea formControlName="collectorNotes" rows="2"></textarea>
            </div>
        </div>
        <div class="footer-code">R0001APR23</div>
    </form>
</div>
